import moment from 'moment'
import { dateToShow, dateToMysql } from '@/helpers/dates'
import { get, filter, map, find } from 'lodash'
import { status } from './dataStatus'

const prepareSearch = search => {
  search.date_start = dateToMysql(search.date_start, 'YYYY-MM-DD 00:00:00')
  search.date_end = dateToMysql(search.date_end, 'YYYY-MM-DD 23:59:59')

  return search
}

const prepareShow = schedule => {
  schedule._selected = false
  schedule.time = moment(schedule.date).format('HH:mm')
  schedule.date = dateToShow(schedule.date)

  schedule._status = get(status, schedule.status, schedule.status)

  return schedule
}

export default {
  prepareShow,
  prepareSearch,
  doLoadAll (searchActive) {
    // if (searchActive) {
    //   this.$v.$touch()
    //   if (this.$v.$error) {
    //     return
    //   }
    // }
    const search = {
      includes: this.includes,
      ...this.defaultSearch,
      ...this.search
    }
    this.loading = true
    this.$resource.get('', this.prepareSearch(search))
      .then(({data, meta}) => {
        this[this.entities] = map(data, this.prepareShow)
        this.afterPrepareShow()
        this.pagination = meta.pagination
        this.loading = false
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  selectAll () {
    const schedules = map(this.schedules, schedule => {
      if (schedule.status !== 'canceled') {
        schedule._selected = this.all
      }

      return schedule
    })

    this.schedules = [...schedules]
  },
  onCloseCancel (schedules) {
    const data = filter(this.schedules, (schedule) => {
      return !find(schedules, {id: schedule.id})
    })

    this.schedules = [...data]
    this.showModalCancel = false
    this.all = false
  },
  onCloseReverser (schedule) {
    const data = filter(this.schedules, (item) => {
      return schedule.id !== item.id
    })

    this.schedules = [...data]
    this.showModalReverser = false
  },
  onCloseTransfer (schedule) {
    const data = filter(this.schedules, (item) => {
      return schedule.id !== item.id
    })

    this.schedules = [...data]
    this.showModalTransfer = false
  },
  hideShowModalCancel () {
    this.showModalCancel = false
  },
  hideShowModalReverser () {
    this.showModalReverser = false
  },
  hideShowModalTransfer () {
    this.showModalTransfer = false
  },

  doCancel (schedule = {}, all = true) {
    if (all) {
      this.schedulesSelected = this.schedules.filter((schedule) => {
        return schedule._selected
      })
    } else {
      this.schedulesSelected = [{...schedule}]
    }
    this.showModalCancel = true
  },
  doReverser (schedule) {
    this.currentSchedule = {...schedule}
    this.showModalReverser = true
  },
  doTransfer (schedule) {
    this.currentSchedule = {...schedule}
    this.showModalTransfer = true
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/history/index/resources/methods.js